function normalizePublicPathname(rawPath) {
    const pathname = rawPath || "/";
    const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
    if (normalizedPath.length > 1 && normalizedPath.endsWith("/"))
        return normalizedPath.slice(0, -1);
    return normalizedPath;
}
export function normalizePublicPathPattern(rawPattern) {
    return normalizePublicPathname(rawPattern);
}
export function parsePublicPathPattern(pathPattern) {
    const normalizedPattern = normalizePublicPathPattern(pathPattern);
    const parameterNames = new Set();
    const segments = normalizedPattern
        .split("/")
        .slice(1)
        .filter(Boolean)
        .map((segment) => {
        if (!segment.startsWith(":")) {
            if (segment.includes("?") || segment.includes("#"))
                throw new Error(`Invalid public route pattern '${pathPattern}'.`);
            return {
                kind: "static",
                value: segment,
            };
        }
        const rawName = segment.slice(1);
        const modifier = rawName.endsWith("?") || rawName.endsWith("*")
            ? rawName.slice(-1)
            : "";
        const name = modifier ? rawName.slice(0, -1) : rawName;
        if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(name))
            throw new Error(`Invalid public route parameter in '${pathPattern}'.`);
        if (parameterNames.has(name))
            throw new Error(`Duplicate public route parameter '${name}' in '${pathPattern}'.`);
        parameterNames.add(name);
        return {
            kind: "parameter",
            name,
            modifier,
        };
    });
    return {
        normalizedPattern,
        segments,
    };
}
export function compilePublicPathPattern(pathPattern) {
    const { normalizedPattern, segments } = parsePublicPathPattern(pathPattern);
    const parameterNames = [];
    let source = "^";
    if (normalizedPattern === "/")
        source += "/";
    for (const segment of segments) {
        if (segment.kind === "static") {
            source += `/${segment.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`;
            continue;
        }
        parameterNames.push(segment.name);
        if (segment.modifier === "?")
            source += "(?:/([^/]+))?";
        else if (segment.modifier === "*")
            source += "(?:/(.*))?";
        else
            source += "/([^/]+)";
    }
    return {
        regex: new RegExp(`${source}$`),
        parameterNames,
    };
}
function parameterValues(value) {
    if (value === undefined || value === null)
        return [];
    return Array.isArray(value) ? value : [value];
}
export function fillPublicPathPattern(pathPattern, params) {
    const { segments } = parsePublicPathPattern(pathPattern);
    const resolved = [];
    for (const segment of segments) {
        if (segment.kind === "static") {
            resolved.push(segment.value);
            continue;
        }
        const optional = segment.modifier === "?" || segment.modifier === "*";
        const values = parameterValues(params[segment.name]).filter((value) => value !== "");
        if (values.length === 0) {
            if (optional)
                continue;
            throw new Error(`Missing public route parameter '${segment.name}' for '${pathPattern}'.`);
        }
        if (segment.modifier !== "*" && values.length !== 1)
            throw new Error(`Public route parameter '${segment.name}' for '${pathPattern}' accepts one value.`);
        for (const value of values) {
            const parts = segment.modifier === "*" ? value.split("/") : [value];
            resolved.push(...parts.filter(Boolean).map(encodeURIComponent));
        }
    }
    return resolved.length === 0 ? "/" : `/${resolved.join("/")}`;
}
//# sourceMappingURL=pathPattern.js.map